const Nurse = () => {
  return (
    <div className="bg-white w-full min-h-screen ">
      {/* Heading */}
      <p className="font-prata mt-20 text-[#185ADB] text-[28px] sm:text-[32px] md:text-[36px] fhd:text-[44px]  mt-10 text-center md:text-left ml-4 sm:ml-6 md:ml-24">
        For Nurses
      </p>

      {/* Main Section */}
      <div className="flex flex-col md:flex-row justify-between items-center gap-8 fhd:gap-0 mt-4 px-4 md:px-10 fhd:px-8">
        {/* Quote Section */}
        <div className="flex flex-col items-start md:ml-10 fhd:-mr-16">
          <img
            src="/assests/startQuot.png"
            alt="quotation start"
            className="h-[32px] w-[32px] sm:h-[40px] sm:w-[40px] md:h-[48px] md:w-[48px] mb-4"
          />
          <p className="text-[#585858] text-[16px] sm:text-[14px] md:text-[18px] lg:text-[22px] fhd:text-[26px] max-w-full md:max-w-[350px] fhd:max-w-[500px] text-center md:text-left lg:text-left font-rubik leading-relaxed mb-6">
            As a nurse, you can connect with patients who require personalized
            home-based care. Ceviliyar app enables you to manage your
            availability, accept appointments, earn more and bring your skills
            to those in need.
          </p>
          <img
            src="/assests/endQuot.png"
            alt="End Quote"
            className="h-[32px] w-[32px] sm:h-[40px] sm:w-[40px] md:h-[48px] md:w-[48px] self-end"
          />
        </div>

        {/* Image Section */}
        <img
          src="/assests/nurseScreen.png"
          alt="Nurse"
          className="w-full max-w-[811px] sm:max-w-[400px] md:max-w-[811px] md:h-[473px] fhd:max-w-[900px] fhd:min-w-[900px] fhd:h-[600px] md:mr-10"
        />
      </div>

      {/* Features Section */}
      <div className="flex flex-col items-center md:flex-row fhd:flex-row fhd:items-end justify-start md:justify-around fhd:justify-center gap-6 md:gap-4 fhd:gap-16 mt-16  fhd:mt-24 mb-8 fhd:mb-18 px-2 md:px-2 lg:px-2 fhd:px-0 mx-4 lg:mx-4 fhd:mx-0">
        {/* Card 1 */}
        <div className="bg-[#EDF3FF] rounded-[16px] p-2 max-w-[400px] md:max-w-[320px] md:h-[100px] fhd:max-w-[440px] fhd:h-[140px] w-full shadow-sm py-5 fhd:p-10 flex-shrink-0">
          <div className="flex items-start">
            <img
              src="/assests/convinient.png"
              alt="Convenient"
              className="h-[32px] w-[32px] object-cover"
            />
            <div className="ml-4">
              <p className="text-[14px] lg:text-[16px] fhd:text-[18px] font-semibold text-[#0D0D2B] font-rubik mb-2">
                Flexible Scheduling
              </p>
              <p className="text-[12px] lg:text-[13px] fhd:text-[16px] text-gray-600 font-rubik">
                Set your availability and accept appointments that fit your
                schedule.
              </p>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="bg-[#EDF3FF] rounded-[16px] p-2 max-w-[420px] fhd:max-w-[440px] fhd:h-[140px] w-full shadow-sm py-5 fhd:p-10 flex-shrink-0">
          <div className="flex items-start">
            <img
              src="/assests/share.png"
              alt="Trusted"
              className="h-[32px] w-[32px] object-cover"
            />
            <div className="ml-4">
              <p className="text-[14px] lg:text-[16px] fhd:text-[18px] font-semibold text-[#0D0D2B] font-rubik mb-2">
                Seamless Connection
              </p>
              <p className="text-[12px] lg:text-[13px] fhd:text-[16px] text-gray-600 font-rubik">
                Connect directly with patients and provide essential nursing
                services at their homes.
              </p>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="bg-[#EDF3FF] rounded-[16px] p-4 max-w-[420px] fhd:max-w-[440px] fhd:h-[140px] w-full shadow-sm py-5 fhd:p-10 flex-shrink-0">
          <div className="flex items-start">
            <img
              src="/assests/sheald.png"
              alt="Easy Management"
              className="h-[30px] w-[30px] object-cover"
            />
            <div className="ml-4">
              <p className="text-[14px] lg:text-[16px] fhd:text-[18px] font-semibold text-[#0D0D2B] font-rubik mb-2">
                Reliable Support
              </p>
              <p className="text-[12px] lg:text-[13px] fhd:text-[16px] text-gray-600 font-rubik">
                Join a platform committed to supporting healthcare professionals
                like you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nurse;
